import * as React from 'react';
import { useSelector } from 'react-redux';
import { useMicrofrontend } from '@cian/mf-react-legacy';

import { useRecommendationsEventsSubscribe } from './hooks/useRecommendationsEventsSubscribe';
import { Recommendations } from '../../components/Recommendations';
import { mapSectionToLandingType } from '../../types/landingType';
import { selectRegionsData } from '../../selectors/mainpage/selectRegionsData';
import { selectPageSection } from '../../selectors/pageSection';
import { isRecommendationsMicrofrontendExists } from './utils/isRecommendationsMicrofrontendExists';
import { useRemovePopularEnabled } from '../../hooks';

export const RecommendationsContainer = () => {
  const microfrontend = useMicrofrontend();
  const section = useSelector(selectPageSection);

  const landingType = React.useMemo(() => mapSectionToLandingType(section), [section]);
  const isEnabled = useRemovePopularEnabled();

  const { subdomainCityId, subdomainRegionId } = useSelector(selectRegionsData);

  useRecommendationsEventsSubscribe(section);

  if (!isRecommendationsMicrofrontendExists(microfrontend)) {
    return null;
  }

  if (section === 'new-buildings' || section === 'commercial') {
    return null;
  }

  return (
    <Recommendations
      regionId={subdomainRegionId || subdomainCityId}
      landingType={landingType}
      showFullList={Number(isEnabled)}
    />
  );
};
